import { gsap, ScrollTrigger, SplitText } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger, SplitText);

export function initBlurSplitText() {
  const animateElements = document.querySelectorAll('[data-title-anim]');
  if (animateElements.length === 0) return;

  animateElements.forEach(animateText => {
    const container =
      animateText.closest('[data-split-container]') ||
      animateText.closest('section');
    const split = SplitText.create(animateText, { type: 'chars' });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: animateText,
        start: 'top 90%',
      },
    });

    tl.set(container, { autoAlpha: 1 }).from(split.chars, {
      duration: 0.8,
      autoAlpha: 0,
      filter: 'blur(10px)',
      y: 10,
      transformOrigin: '50% 50%',
      stagger: {
        each: 0.05,
        from: 'center',
      },
      ease: 'sine.inOut',
    });
  });
}

export function initParallax() {
  const triggers = document.querySelectorAll('[data-parallax-trigger]');
  if (triggers.length === 0) return;

  triggers.forEach(trigger => {
    const parallaxElements = trigger.querySelectorAll(
      '[data-parallax-animate]'
    );

    parallaxElements.forEach(elem => {
      const target = elem.querySelector('img') || elem;

      gsap.fromTo(
        target,
        { yPercent: -20 },
        {
          yPercent: 20,
          scrollTrigger: {
            trigger: trigger,
            start: 'top 95%',
            end: 'bottom 0%',
            scrub: true,
          },
        }
      );
    });
  });
}

export function initFadeIn() {
  const triggers = document.querySelectorAll('[data-fade-in-trigger]');

  triggers.forEach(trigger => {
    const targets = trigger.querySelectorAll('[data-fade-in-target]');
    if (targets.length === 0) return;

    gsap.from(targets, {
      y: 100,
      duration: 1.2,
      ease: 'sine.inOut',
      opacity: 0,
      stagger: 0.2,
      scrollTrigger: {
        trigger: trigger,
        start: 'top 100%',
        toggleActions: 'play none none reverse',
      },
    });
  });
}

export function initFadeInOnScroll() {
  const targetElements = document.querySelectorAll('[data-fade-out-target]');
  if (!targetElements || targetElements.length === 0) return;

  targetElements.forEach(elem => {
    gsap.from(elem, {
      y: 100,
      opacity: 0,
      duration: 1,
      ease: 'sine.inOut',
      scrollTrigger: {
        trigger: elem,
        start: 'top 90%',
        toggleActions: 'play none none reverse',
      },
    });
  });
}
